if (!customElements.get('metafield-collections-slider')) {
  customElements.define(
    'metafield-collections-slider',
    class MetafieldCollectionsSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          sliderWrap: '.metafield-collections-slider__wrap',
          sliderInner: '.metafield-collections-slider__inner',
        };

        this.classes = {
          flex: 'f-flex',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sliderWrap = this.querySelector(this.selectors.sliderWrap);
        this.sliderInner = this.querySelector(this.selectors.sliderInner);
        this.sliderInstance = false;

        if (!this.sliderWrap || !this.sliderInner) return;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
        // Always initialize the slider
        this.initSlider();
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        const items = parseInt(this.dataset.items);
        const itemsMobile = parseInt(this.dataset.itemsMobile);
        const columnGap = window.getComputedStyle(this.sliderInner).getPropertyValue('--column-gap') || window.getComputedStyle(this.sliderInner).getPropertyValue('--gap-x') || '2.4rem';
        const columnGapMobile = window.getComputedStyle(this.sliderInner).getPropertyValue('--column-gap-mobile') || window.getComputedStyle(this.sliderInner).getPropertyValue('--gap-x') || '1.2rem';
        const spaceBetween = columnGap ? parseFloat(columnGap.replace('rem', '').trim()) * 10 : 24;
        const spaceBetweenMobile = columnGapMobile ? parseFloat(columnGapMobile.replace('rem', '').trim()) * 10 : 12;

        this.sliderOptions = {
          slidesPerView: 2,
          spaceBetween: spaceBetweenMobile,
          breakpoints: {
            768: {
              slidesPerView: 4,
              spaceBetween: spaceBetween,
            },
            1024: {
              slidesPerView: 5,
              spaceBetween: spaceBetween,
            },
            1300: {
              slidesPerView: 6,
              spaceBetween: spaceBetween,
            },
          },
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
            type: 'fraction',
          },
          loop: false,
          threshold: 2,
          grabCursor: true,
          allowTouchMove: true,
          on: {
            init: () => {
              // Remove initializing class after Swiper is initialized
              requestAnimationFrame(() => {
                this.sliderWrap.classList.remove('metafield-collections-slider__wrap--initializing');
              });
            }
          }
        };

        this.sliderWrap.classList.add(this.classes.swiper);
        this.sliderInner.classList.remove(this.classes.flex);
        this.sliderInner.classList.add(this.classes.swiperWrapper);
        
        this.sliderInstance = new window.FoxTheme.Carousel(this.sliderWrap, this.sliderOptions);
        this.sliderInstance.init();

        this.handleAccessibility();
      }

      handleAccessibility() {
        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', (event) => {
            if (event.relatedTarget !== null) {
              if (element.closest('.swiper-slide')) {
                const slide = element.closest('.swiper-slide');
                this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
              }
            } else {
              element.blur();
            }
          });
        });
      }

      destroySlider() {
        this.sliderWrap.classList.remove(this.classes.swiper);
        this.sliderInner.classList.remove(this.classes.swiperWrapper);
        this.sliderInner.classList.add(this.classes.flex);
        // Remove initializing class when slider is destroyed (not using slider)
        this.sliderWrap.classList.remove('metafield-collections-slider__wrap--initializing');
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  );
}

